import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { LocaleService } from 'src/app/core/locale/locale.service';

@Directive({
	selector: '[ahpHasLocale]',
})
export class HasLocaleDirective {
	/**
	 * If the view has been rendered
	 */
	private hasView: boolean;

	@Input()
	set ahpHasLocale(sectionTarget: string) {
		const hasLocale = this.locale.has(sectionTarget);
		const { hasView } = this;

		if (hasLocale && !hasView) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			this.hasView = true;
		} else if (!hasLocale && hasView) {
			this.viewContainer.clear();
			this.hasView = false;
		}
	}

	/**
	 * Our directive constructor
	 * @param templateRef The template reference
	 * @param viewContainer The view container reference
	 */
	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private locale: LocaleService
	) {}
}
